import {
  DEFAULT_BUTTON_TO_UPDATE_TEXT,
  DISABLED_BUTTON_TO_UPDATE_FILL_COLOR,
  DISABLED_BUTTON_TO_UPDATE_FONT_COLOR,
  UPDATE_BUTTON_IDX,
} from "../../constants";

export const uploadButtonInactiveStyles = (table: Excel.Table, row: number) => {
  const actionButton = table.columns.getItemAt(UPDATE_BUTTON_IDX).getRange().getCell(row, 0);

  actionButton.format.fill.color = DISABLED_BUTTON_TO_UPDATE_FILL_COLOR;
  actionButton.format.font.color = DISABLED_BUTTON_TO_UPDATE_FONT_COLOR;
  actionButton.values = [[DEFAULT_BUTTON_TO_UPDATE_TEXT]];
};
